import { useTranslation } from "react-i18next"
import { Outlet } from "react-router"

import { BrandMark } from "@/components/shared/brand"
import { LanguageToggle, ThemeToggle } from "@/components/shared/preference-toggles"

/** S01 shell: form pane (start/right) + brand pane (end/left, hidden below 1024 px). */
export function AuthLayout() {
  const { t } = useTranslation()
  return (
    <div className="grid min-h-dvh bg-card lg:grid-cols-[640px_1fr]">
      <div className="flex flex-col justify-center px-6 py-10 sm:px-16 lg:px-24">
        <div className="mx-auto w-full max-w-[468px]">
          <div className="mb-10 flex items-center gap-3">
            <BrandMark width={56} height={34} />
            <div className="flex-1 leading-tight">
              <div className="text-lg font-bold">{t("app.name")}</div>
              <div className="text-[13px] text-muted-foreground">{t("app.taglineLong")}</div>
            </div>
            <div className="flex items-center gap-1">
              <LanguageToggle />
              <ThemeToggle size="icon" />
            </div>
          </div>
          <Outlet />
        </div>
      </div>
      <aside className="relative hidden overflow-hidden bg-hero text-white lg:flex lg:items-center">
        <div aria-hidden className="absolute -top-40 -start-24 size-[520px] rounded-full border border-white/15" />
        <div aria-hidden className="absolute -top-20 -start-40 size-[420px] rounded-full border border-white/15" />
        <div aria-hidden className="absolute -end-10 -bottom-48 size-[440px] rounded-full bg-white/10" />
        <div className="relative max-w-[560px] px-16">
          <p className="text-[15px] text-white/85">{t("auth.agency")}</p>
          <h2 className="mt-4 text-[44px] leading-[1.35] font-bold">{t("auth.headline")}</h2>
          <p className="mt-6 text-lg leading-relaxed text-white/85">{t("auth.body")}</p>
          <ul className="mt-8 flex flex-wrap gap-3">
            {[t("auth.pills.bookings"), t("auth.pills.invoices"), t("auth.pills.billing")].map((p) => (
              <li key={p} className="rounded-full bg-white/10 px-4 py-2 text-[15px] font-medium">
                {p}
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </div>
  )
}
